import React, { useEffect } from 'react';
import { useResidentData } from '../hooks/useResidentData';
import { LoadingBar } from '../../components/common/LoadingBar';
import { formatDate, formatCurrency } from '../../components/common';
import '../../components/common/CRMForm.css';

const LeaseInfoSection: React.FC = () => {
  const { lease, isLoading: globalLoading, loadingMessage, error, fetchLease } = useResidentData();

  useEffect(() => {
    fetchLease();
  }, [fetchLease]);

  if (globalLoading) {
    return <LoadingBar isLoading={globalLoading} message={loadingMessage} />;
  }

  if (error) {
    return (
      <section className="form-section">
        <div className="form-section-content">
          <div className="app-error-message">Error: {error}</div>
        </div>
      </section>
    );
  }

  if (!lease) {
    return (
      <section className="form-section">
        <div className="form-section-content">
          <div className="app-welcome-message">
            <p>Lease information unavailable.</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="form-section">
      <h3>Lease Information</h3>
      <div className="form-section-content">
        <div className="app-form-row">
          <div className="app-form-group">
            <label className="app-form-label">Lease Type</label>
            <p className="app-form-display">{lease.typeName || 'N/A'}</p>
          </div>
          <div className="app-form-group">
            <label className="app-form-label">Tenant</label>
            <p className="app-form-display">{lease.tenantName || 'N/A'}</p>
          </div>
        </div>

        <div className="app-form-group">
          <label className="app-form-label">Property Address</label>
          <p className="app-form-display">{lease.propertyAddress || 'N/A'}</p>
        </div>

        <div className="app-form-row">
          <div className="app-form-group">
            <label className="app-form-label">Begin Date</label>
            <p className="app-form-display">{formatDate(lease.beginDate)}</p>
          </div>
          <div className="app-form-group">
            <label className="app-form-label">End Date</label>
            <p className="app-form-display">{lease.endDate ? formatDate(lease.endDate) : 'N/A'}</p>
          </div>
        </div>

        <div className="app-form-row">
          <div className="app-form-group">
            <label className="app-form-label">Lease Amount</label>
            <p className="app-form-display">{lease.leaseAmount ? formatCurrency(lease.leaseAmount) : 'N/A'}</p>
          </div>
          <div className="app-form-group">
            <label className="app-form-label">Security Amount</label>
            <p className="app-form-display">{lease.securityAmount ? formatCurrency(lease.securityAmount) : 'N/A'}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeaseInfoSection;

